import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import type { CustomAttribute, Primitive } from "@similarweb/sw-track";

const createSignalsAlertsTrackingService = (track: TrackFn) => {
    const trackSignalAlertEvent = (
        action: string,
        name: string,
        customAttributes?: Record<CustomAttribute, Primitive>,
    ) => {
        track("email alert", action, name, customAttributes);
    };

    return {
        trackAlertFrequenciesToggle(isOpen: boolean, label: string): void {
            if (isOpen) {
                trackSignalAlertEvent("click on email frequency", `open email frequency/${label.toLowerCase()}`);
            }
        },
        trackAlertFrequencySelect(label: string) {
            trackSignalAlertEvent("select email frequency", `email frequency/${label.toLowerCase()}`);
        },
        trackNoSettingsClick() {
            trackSignalAlertEvent("define first signal", "tooltip define link");
        },
    };
};

export default createSignalsAlertsTrackingService;
